import { http, type HttpClient } from './core/http-client';
import type {
  ActionCount,
  ActivityEntry,
  ActivityFilters,
  BusinessMatch,
  PlatformRole,
  RoleOption,
  StaffMember,
  StaffPermissionOption,
  UserMatch,
} from './models';

// Super admins only, behind two-step verification. Not tenant-scoped.
export class PlatformAdminService {
  constructor(private readonly http: HttpClient) {}

  activity = (
    filters: ActivityFilters & { cursor?: string; limit?: number },
    signal?: AbortSignal,
  ) => this.http.getPage<ActivityEntry>('/admin/activity', { query: { ...filters }, signal });

  actions = () => this.http.get<ActionCount[]>('/admin/activity/actions');

  findBusinesses = (q: string) =>
    this.http.get<BusinessMatch[]>('/admin/lookup/businesses', { query: { q } });

  findUsers = (q: string) => this.http.get<UserMatch[]>('/admin/lookup/users', { query: { q } });

  staff = () => this.http.get<StaffMember[]>('/admin/staff');

  roles = () => this.http.get<RoleOption[]>('/admin/staff/roles');

  permissions = () => this.http.get<StaffPermissionOption[]>('/admin/staff/permissions');

  setPermission = (userId: string, permission: string, enabled: boolean) =>
    this.http.put<{ changed: boolean; enabled: boolean }>(`/admin/staff/${userId}/permissions`, {
      permission,
      enabled,
    });

  setRole = (userId: string, role: PlatformRole) =>
    this.http.put<{ userId: string; role: PlatformRole; changed: boolean }>(
      `/admin/staff/${userId}/role`,
      { role },
    );
}

export const platformAdminService = new PlatformAdminService(http);
